import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// Ajoutez ce code à votre fichier JavaScript principal
document.addEventListener("DOMContentLoaded", function () {
  const cartButton = document.querySelector(".cart-button");
  const cartClose = document.querySelector(".sidemenu-cart-close");
  const cartOverlay = document.querySelector(".offcanvas__overlay");
  const cartSidebar = document.querySelector(".sidemenu-wrapper-cart");

  if (cartButton) {
    cartButton.addEventListener("click", function () {
      cartOverlay.classList.add("active");
      cartSidebar.classList.add("active");
    });
  }

  if (cartClose) {
    cartClose.addEventListener("click", function () {
      cartOverlay.classList.remove("active");
      cartSidebar.classList.remove("active");
    });
  }

  if (cartOverlay) {
    cartOverlay.addEventListener("click", function () {
      cartOverlay.classList.remove("active");
      cartSidebar.classList.remove("active");
    });
  }
});
